import { render, staticRenderFns } from "./CommentRenderer.vue?vue&type=template&id=26e3d045"
import script from "./CommentRenderer.vue?vue&type=script&lang=js"
export * from "./CommentRenderer.vue?vue&type=script&lang=js"
import style0 from "./CommentRenderer.vue?vue&type=style&index=0&id=26e3d045&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/latinad/panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26e3d045')) {
      api.createRecord('26e3d045', component.options)
    } else {
      api.reload('26e3d045', component.options)
    }
    module.hot.accept("./CommentRenderer.vue?vue&type=template&id=26e3d045", function () {
      api.rerender('26e3d045', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/table-cells/CommentRenderer.vue"
export default component.exports